module.exports = __webpack_public_path__ + "img/call.9e299bb3.png";